import { without } from 'lodash';
import { labeled, enumRequired } from '../../util/joi';
import { schema as objectiveTypeBaseReasonFixedAndVariableRate } from './ObjectiveTypeBaseReasonFixedAndVariableRate.schema';
import { ImportantOption, importantOptions } from '../global/ImportantOption.enum';
import {
  ObjectivePreferredDurationOption,
  objectivePreferredDurationOptions
} from './ObjectivePreferredDurationOption.enum';

export const schema = (Joi: any, label: string) => {
  const availableImportantOptions = without(
    importantOptions,
    ImportantOption.none.name,
    ImportantOption.most_important.name,
    ImportantOption.somewhat_important.name,
    ImportantOption.least_important.name
  );
  const availableObjectivePreferredDurationOptions = without(
    objectivePreferredDurationOptions,
    ObjectivePreferredDurationOption.none.name,
    ObjectivePreferredDurationOption.up_to_one_year.name,
    ObjectivePreferredDurationOption.one_to_three_years.name,
    ObjectivePreferredDurationOption.three_to_five_years.name,
    ObjectivePreferredDurationOption.five_years_plus.name
  );
  return Joi.object()
    .keys({
      type: enumRequired(
        Joi,
        availableImportantOptions,
        labeled(label, 'Fixed and variable rate')
      )
    })
    .when(
      Joi.object({
        type: Joi.object().keys({ name: Joi.string().valid(ImportantOption?.important?.name) })
      }),
      {
        then: Joi.object({
          preferredDuration: enumRequired(
            Joi,
            availableObjectivePreferredDurationOptions,
            labeled(label, 'Indicate the preferred duration of the fixed rate period')
          ),
          reason: objectiveTypeBaseReasonFixedAndVariableRate(
            Joi,
            labeled(label, 'Where fixed and variable rate is important, why? - ')
          )
        })
      }
    );
};

export default {
  schema
};
